export default {"src":"/_next/static/media/mongodb-icon.93444fe9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};